var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-container",class:{'overflow-container-active': _vm.hasOverflow}},[_vm._t("default"),(_vm.hasOverflow && _vm.count)?_c('div',{staticClass:"overflow-container-count",attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.count)+" items")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }